// Comprehensive EN/FR dictionary for Midemide Logistics
// Keys are dot-namespaced. Missing FR keys fall back to EN.

export const translations = {
  en: {
    // Header / Nav
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.track": "Track",
    "nav.valueProposition": "Why Us",
    "nav.careers": "Careers",
    "nav.blog": "Blog",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.login": "Log in",
    "nav.logout": "Logout",
    "nav.dashboard": "Dashboard",
    "nav.adminInbox": "Admin Inbox",
    "nav.adminBlog": "Manage Blog",
    "nav.requestQuote": "Request Quote",
    "nav.language": "Language",
    "common.streamliningLogistics": "Streamlining Logistics",

    // Hero
    "hero.headline1": "Reliable Freight Transport",
    "hero.headline2": "& Brokerage Services",
    "hero.headline3": "3PL Logistics Solutions across Canada, United States and International.",
    "hero.subtitle": "Dedicated Transportation, Final-Mile Delivery, Supply Chain Support & Asset-Based Logistics Solutions — engineered for shippers who can't afford to gamble on their freight.",
    "hero.badge": "Freight Brokerage · Est. 2014",
    "hero.requestQuote": "Request a Quote",
    "hero.contactDispatch": "Contact Dispatch",
    "hero.panelOverline": "Dispatch · 24 / 7",
    "hero.panelTitle": "Speak to our specialists.",
    "hero.panelSub": "Our dispatchers answer in seconds — not in 48 hours.",
    "hero.panelCallNow": "Call Now",
    "hero.panelEmailUs": "Email Dispatch",
    "hero.stat1k": "10+", "hero.stat1v": "Years In Operation",
    "hero.stat2k": "8,500+", "hero.stat2v": "Shipments Delivered",
    "hero.stat3k": "4", "hero.stat3v": "Industries Served",
    "hero.stat4k": "24/7", "hero.stat4v": "Dispatch Coverage",

    // Industries Marquee
    "industries.construction": "CONSTRUCTION",
    "industries.engineering": "ENGINEERING",
    "industries.energy": "ENERGY",
    "industries.cabinetry": "CABINETRY",
    "industries.manufacturing": "MANUFACTURING",
    "industries.agriculture": "AGRICULTURE",

    // Services Grid
    "services.overline": "[ 02 ] Services",
    "services.headline": "Engineered for cargo most carriers won't touch.",
    "services.intro": "We move what matters when standard freight networks reach their limit — oversized HVAC units, modular construction components, energy infrastructure and high-value cabinetry. From single-package express to international containerised transport, we operate the full spectrum.",
    "services.flagship": "Flagship",
    "services.specialized.title": "Specialized & Oversized",
    "services.specialized.desc": "Crated industrial equipment, modular construction units, custom-built HVAC systems. Permits, escorts and route planning handled in-house.",
    "services.specialized.cta": "Quote oversized",
    "services.flatbed.title": "Flatbed Transport",
    "services.flatbed.desc": "Open-deck moves for steel, lumber, machinery and over-dimensional loads.",
    "services.ltl.title": "LTL & FTL",
    "services.ltl.desc": "Less-than-truckload pooling and full-truckload exclusivity.",
    "services.crossborder.title": "Cross-Border CA / US",
    "services.crossborder.desc": "Bonded carriers, customs documentation, PARS/PAPS, ACE / ACI manifests. Daily lanes between Ontario, Quebec and the US Midwest.",
    "services.international.title": "International & Containers",
    "services.international.desc": "FCL / LCL ocean freight with port-to-door handling.",
    "services.smallpkg.title": "Small Package & Express",
    "services.smallpkg.desc": "Same-day, next-day and expedited courier across the GTA and beyond.",
    "services.smallpkg.cta": "Get a Rate",
    "services.dryvan.title": "Dry Van",
    "services.dryvan.desc": "Enclosed 53-ft trailers for general freight, palletised goods and protected cargo.",
    "services.conestoga.title": "Conestoga",
    "services.conestoga.desc": "Retractable curtain-side trailers — flatbed access with weather protection for sensitive freight.",
    "services.warehouse.title": "3PL Warehousing",
    "services.warehouse.desc": "Storage, cross-docking, inventory management and pick-and-pack — the warehouse arm of your supply chain.",

    // About Stats
    "about.overline": "[ 03 ] Our story",
    "about.headline": "A decade of moving the difficult cargo.",
    "about.p1": "Midemide Logistics Inc. has been streamlining transportation and distribution for manufacturers and distributors since 2014. We built our reputation in construction, engineering, energy and cabinetry — verticals where freight is heavy, oversized, time-sensitive and rarely standard.",
    "about.p2": "Our network of vetted carriers across Canada, the United States and overseas allows us to compare rates instantly, dispatch within the hour and stay with your shipment until the bill of lading is signed.",
    "about.years": "Years in business",
    "about.shipments": "Shipments moved",
    "about.quotes": "Quotes processed",
    "about.builtBy": "Built by",
    "about.builtByLine": "Operators who've been in the cab.",

    // Testimonials
    "testimonials.overline": "[ 04 ] Voices from the road",
    "testimonials.headline": "What dispatchers, ops directors and owners say.",

    // CTA Banner
    "cta.overline": "Dispatch on call · 24 / 7",
    "cta.headline1": "Got a load to move",
    "cta.headline2": "on time?",
    "cta.headline3": "Send it across.",
    "cta.sub": "FTL, LTL, Oversized, Dry-Van or Special Equipment — our dispatchers move what others won't touch.",
    "cta.request": "Request Quote",
    "cta.talk": "Talk to Dispatch",

    // Footer
    "footer.tagline": "Streamlining transportation and distribution for construction, engineering, energy and cabinetry — across Canada, the US and overseas since 2014.",
    "footer.company": "Company",
    "footer.services": "Services",
    "footer.contact": "Contact",
    "footer.legal": "Legal",
    "footer.privacy": "Privacy",
    "footer.terms": "Terms",
    "footer.allRights": "All rights reserved.",
    "footer.followUs": "Follow us",

    // Quote page
    "quote.overline": "Get a Quote",
    "quote.headline1": "Quote in minutes.",
    "quote.headline2": "Booked in hours.",
    "quote.sub": "Tell us your shipment. We'll show you live rates from our vetted carrier network.",
    "quote.step.route": "Route",
    "quote.step.cargo": "Cargo",
    "quote.step.bestRate": "Best Rate",
    "quote.step.contact": "Contact",
    "quote.step1.title": "Where is it going?",
    "quote.origin": "Origin (City, Province/State) *",
    "quote.destination": "Destination *",
    "quote.serviceType": "Service Type *",
    "quote.continue": "Continue",
    "quote.back": "Back",
    "quote.step2.title": "What's the cargo?",
    "quote.cargoDescription": "Cargo Description",
    "quote.cargoPlaceholder": "HVAC rooftop unit, crated",
    "quote.weight": "Weight *",
    "quote.pickupDate": "Pickup Date",
    "quote.quantityUnit": "Quantity & Unit Type *",
    "quote.unitsCount": "# of units",
    "quote.unitHint": "e.g. 4 pallets, 12 crates, 1 oversized piece. Dimensions below are per-unit.",
    "quote.unit.pallets": "Pallets",
    "quote.unit.skids": "Skids",
    "quote.unit.crates": "Crates",
    "quote.unit.boxes": "Boxes / Cartons",
    "quote.unit.drums": "Drums / Barrels",
    "quote.unit.pieces": "Pieces / Units",
    "quote.unit.rolls": "Rolls",
    "quote.unit.bundles": "Bundles",
    "quote.unit.containers": "Containers",
    "quote.dimensions": "Dimensions per unit (L × W × H)",
    "quote.notes": "Notes for Dispatch",
    "quote.notesPlaceholder": "Special handling, residential pickup, dock height, etc.",
    "quote.calculating": "Calculating…",
    "quote.getBestRate": "Get Best Rate",
    "quote.summaryRates": "Cheapest verified rate · Final price confirmed by dispatch",
    "quote.dispatchNote": "Think we can do better? Our dispatchers often unlock sharper pricing on direct lanes — call",
    "quote.dispatchNoteOr": "or email",
    "quote.step4.title": "Where do we send confirmation?",
    "quote.fullName": "Full Name *",
    "quote.email": "Email *",
    "quote.phone": "Phone",
    "quote.company": "Company",
    "quote.selectedCarrier": "Selected Carrier",
    "quote.submitting": "Submitting…",
    "quote.submitToDispatch": "Submit to Dispatch",
    "quote.continueWith": "Continue with",
    "quote.selection": "Selection",
    "quote.successOverline": "Quote Submitted",
    "quote.reference": "Reference",
    "quote.successMsg": "Our dispatch team has received your request and will reach out within one business hour to confirm pricing and schedule pickup.",
    "quote.lockTitle": "Lock this rate for 24 hours",
    "quote.lockSub": "Hold your price while you finalise logistics on your side.",
    "quote.locked": "Rate locked — approved by dispatch",
    "quote.lockedSub": "Your price is held while dispatch finalises pickup.",
    "quote.expiresIn": "Expires in",
    "quote.lockBtn": "Lock Rate for 24 Hours",
    "quote.lockToast": "Rate locked for 24 hours. Dispatch has been notified.",
    "quote.escalate": "Need to escalate? Email",
    "quote.trackShipment": "Track a Shipment",
    "quote.backHome": "Back to Home",
    "quote.guaranteed": "Guaranteed transit",
    "quote.day": "day",
    "quote.days": "days",
    "quote.noRates": "No rates available for this lane right now. Please contact dispatch directly.",

    // Service options (re-used in Quote)
    "svcOpt.ltl.label": "LTL Freight",
    "svcOpt.ltl.desc": "Less-than-truckload pooled freight",
    "svcOpt.ftl.label": "FTL / Dry Van",
    "svcOpt.ftl.desc": "Full-truckload exclusive trailer",
    "svcOpt.flatbed.label": "Flatbed",
    "svcOpt.flatbed.desc": "Open deck for over-dimensional cargo",
    "svcOpt.conestoga.label": "Conestoga",
    "svcOpt.conestoga.desc": "Retractable curtain-side trailer",
    "svcOpt.specialized.label": "Specialized / Oversized",
    "svcOpt.specialized.desc": "Heavy haul, permits, escorts",
    "svcOpt.container.label": "Container (FCL/LCL)",
    "svcOpt.container.desc": "20'/40' ocean freight",
    "svcOpt.small_package.label": "Small Package",
    "svcOpt.small_package.desc": "Couriered express",
    "svcOpt.cross_border.label": "Cross-Border CA/US",
    "svcOpt.cross_border.desc": "Bonded carriers + customs",
    "svcOpt.international.label": "International",
    "svcOpt.international.desc": "Overseas door-to-door",
    "svcOpt.warehousing.label": "3PL Warehousing",
    "svcOpt.warehousing.desc": "Storage, cross-dock & pick-pack",

    // Track page (minimal)
    "track.overline": "Track a Shipment",
    "track.headline": "Where's your freight right now?",
    "track.sub": "Enter your reference number to see real-time status.",
    "track.placeholder": "MDLGX-XXXXXX-XXXXXX",
    "track.btn": "Track",
    "track.searching": "Searching…",
    "track.notFound": "We couldn't find that reference. Double-check the number or contact dispatch.",

    // Contact
    "contact.overline": "Contact",
    "contact.headline": "Talk to a dispatcher.",
    "contact.sub": "Need a quote, escalation or just want to talk freight? Drop us a line — we respond in under an hour during business hours.",
    "contact.name": "Full Name *",
    "contact.email": "Email *",
    "contact.phone": "Phone",
    "contact.companyField": "Company",
    "contact.message": "Message *",
    "contact.send": "Send Message",
    "contact.sending": "Sending…",
    "contact.success": "Message received. Our dispatch team will respond within one business hour.",

    // Lead Capture
    "lead.title": "Get freight market intel.",
    "lead.sub": "Monthly rate updates, lane trends and dispatch tips. No spam.",
    "lead.placeholder": "your@email.com",
    "lead.btn": "Subscribe",
    "lead.success": "You're in. Watch your inbox.",
    "lead.dismiss": "Dismiss",

    // Auth
    "auth.login.title": "Welcome back",
    "auth.login.sub": "Sign in to manage quotes, shipments and your dispatch profile.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login": "Sign in",
    "auth.noAccount": "Don't have an account?",
    "auth.register": "Create one",
    "auth.register.title": "Create your account",
    "auth.register.sub": "Track quotes & shipments in one place.",
    "auth.name": "Full Name",
    "auth.phone": "Phone (optional)",
    "auth.companyField": "Company (optional)",
    "auth.createBtn": "Create account",
    "auth.haveAccount": "Already have an account?",
    "auth.signIn": "Sign in",
  },

  fr: {
    // Header / Nav
    "nav.home": "Accueil",
    "nav.services": "Services",
    "nav.track": "Suivi",
    "nav.valueProposition": "Pourquoi nous",
    "nav.careers": "Carrières",
    "nav.blog": "Blogue",
    "nav.about": "À propos",
    "nav.contact": "Contact",
    "nav.login": "Connexion",
    "nav.logout": "Déconnexion",
    "nav.dashboard": "Tableau de bord",
    "nav.adminInbox": "Boîte admin",
    "nav.adminBlog": "Gérer le blogue",
    "nav.requestQuote": "Demander un devis",
    "nav.language": "Langue",
    "common.streamliningLogistics": "Logistique optimisée",

    // Hero
    "hero.headline1": "Transport de fret fiable",
    "hero.headline2": "et services de courtage",
    "hero.headline3": "Solutions logistiques 3PL à travers le Canada, les États-Unis et l'international.",
    "hero.subtitle": "Transport dédié, livraison du dernier kilomètre, soutien à la chaîne d'approvisionnement et solutions logistiques avec actifs — conçus pour les expéditeurs qui ne peuvent pas se permettre de prendre des risques avec leur marchandise.",
    "hero.badge": "Courtier de fret · Depuis 2014",
    "hero.requestQuote": "Demander un devis",
    "hero.contactDispatch": "Contacter la répartition",
    "hero.panelOverline": "Répartition · 24 / 7",
    "hero.panelTitle": "Parlez à nos spécialistes.",
    "hero.panelSub": "Nos répartiteurs répondent en quelques secondes — pas en 48 heures.",
    "hero.panelCallNow": "Appeler maintenant",
    "hero.panelEmailUs": "Écrire à la répartition",
    "hero.stat1k": "10+", "hero.stat1v": "Années d'activité",
    "hero.stat2k": "8 500+", "hero.stat2v": "Expéditions livrées",
    "hero.stat3k": "4", "hero.stat3v": "Industries desservies",
    "hero.stat4k": "24/7", "hero.stat4v": "Répartition continue",

    // Industries
    "industries.construction": "CONSTRUCTION",
    "industries.engineering": "INGÉNIERIE",
    "industries.energy": "ÉNERGIE",
    "industries.cabinetry": "ÉBÉNISTERIE",
    "industries.manufacturing": "FABRICATION",
    "industries.agriculture": "AGRICULTURE",

    // Services
    "services.overline": "[ 02 ] Services",
    "services.headline": "Conçu pour la cargaison que la plupart des transporteurs refusent.",
    "services.intro": "Nous transportons ce qui compte lorsque les réseaux standards atteignent leurs limites — unités de CVC surdimensionnées, composants de construction modulaire, infrastructures énergétiques et ébénisterie haut de gamme. De l'express colis unique au transport international par conteneur, nous couvrons tout le spectre.",
    "services.flagship": "Phare",
    "services.specialized.title": "Spécialisé & surdimensionné",
    "services.specialized.desc": "Équipement industriel emballé, unités modulaires, systèmes CVC sur mesure. Permis, escortes et planification d'itinéraires gérés à l'interne.",
    "services.specialized.cta": "Devis surdimensionné",
    "services.flatbed.title": "Transport à plate-forme",
    "services.flatbed.desc": "Plate-formes ouvertes pour acier, bois, machinerie et charges hors gabarit.",
    "services.ltl.title": "LTL & FTL",
    "services.ltl.desc": "Chargement partiel groupé et chargement complet exclusif.",
    "services.crossborder.title": "Transfrontalier CA / US",
    "services.crossborder.desc": "Transporteurs cautionnés, documentation douanière, PARS/PAPS, manifestes ACE / ACI. Liaisons quotidiennes Ontario-Québec-Midwest américain.",
    "services.international.title": "International & conteneurs",
    "services.international.desc": "Fret maritime FCL / LCL avec gestion port-à-porte.",
    "services.smallpkg.title": "Petits colis & express",
    "services.smallpkg.desc": "Coursier le jour même, le lendemain et accéléré dans la grande région et au-delà.",
    "services.smallpkg.cta": "Obtenir un tarif",
    "services.dryvan.title": "Fourgon sec",
    "services.dryvan.desc": "Remorques fermées de 53 pi pour fret général, marchandises palettisées et cargaisons protégées.",
    "services.conestoga.title": "Conestoga",
    "services.conestoga.desc": "Remorques à toile rétractable — accès plate-forme avec protection contre les intempéries.",
    "services.warehouse.title": "Entreposage 3PL",
    "services.warehouse.desc": "Entreposage, transbordement, gestion d'inventaire et préparation de commandes — le bras logistique de votre chaîne.",

    // About
    "about.overline": "[ 03 ] Notre histoire",
    "about.headline": "Une décennie à transporter la cargaison difficile.",
    "about.p1": "Midemide Logistics Inc. optimise le transport et la distribution pour les fabricants et distributeurs depuis 2014. Nous avons bâti notre réputation dans la construction, l'ingénierie, l'énergie et l'ébénisterie — des secteurs où le fret est lourd, surdimensionné, urgent et rarement standard.",
    "about.p2": "Notre réseau de transporteurs vérifiés au Canada, aux États-Unis et outre-mer nous permet de comparer les tarifs instantanément, d'expédier dans l'heure et de suivre votre expédition jusqu'à la signature du connaissement.",
    "about.years": "Années d'activité",
    "about.shipments": "Expéditions transportées",
    "about.quotes": "Devis traités",
    "about.builtBy": "Bâti par",
    "about.builtByLine": "Des opérateurs qui ont été au volant.",

    // Testimonials
    "testimonials.overline": "[ 04 ] Voix de la route",
    "testimonials.headline": "Ce que disent les répartiteurs, directeurs d'opérations et propriétaires.",

    // CTA Banner
    "cta.overline": "Répartition en ligne · 24 / 7",
    "cta.headline1": "Un chargement à livrer",
    "cta.headline2": "à temps ?",
    "cta.headline3": "Envoyez-le-nous.",
    "cta.sub": "FTL, LTL, surdimensionné, fourgon sec ou équipement spécial — nos répartiteurs transportent ce que d'autres refusent.",
    "cta.request": "Demander un devis",
    "cta.talk": "Parler à la répartition",

    // Footer
    "footer.tagline": "Nous optimisons le transport et la distribution pour la construction, l'ingénierie, l'énergie et l'ébénisterie — à travers le Canada, les États-Unis et outre-mer depuis 2014.",
    "footer.company": "Entreprise",
    "footer.services": "Services",
    "footer.contact": "Contact",
    "footer.legal": "Mentions légales",
    "footer.privacy": "Confidentialité",
    "footer.terms": "Conditions",
    "footer.allRights": "Tous droits réservés.",
    "footer.followUs": "Suivez-nous",

    // Quote page
    "quote.overline": "Obtenez un devis",
    "quote.headline1": "Devis en minutes.",
    "quote.headline2": "Réservé en heures.",
    "quote.sub": "Décrivez votre envoi. Nous vous montrons les tarifs en direct de notre réseau de transporteurs vérifiés.",
    "quote.step.route": "Itinéraire",
    "quote.step.cargo": "Cargaison",
    "quote.step.bestRate": "Meilleur tarif",
    "quote.step.contact": "Contact",
    "quote.step1.title": "Où va-t-elle ?",
    "quote.origin": "Origine (Ville, Province/État) *",
    "quote.destination": "Destination *",
    "quote.serviceType": "Type de service *",
    "quote.continue": "Continuer",
    "quote.back": "Retour",
    "quote.step2.title": "Quelle est la cargaison ?",
    "quote.cargoDescription": "Description de la cargaison",
    "quote.cargoPlaceholder": "Unité CVC de toit, emballée",
    "quote.weight": "Poids *",
    "quote.pickupDate": "Date de ramassage",
    "quote.quantityUnit": "Quantité & type d'unité *",
    "quote.unitsCount": "Nb. d'unités",
    "quote.unitHint": "Ex. 4 palettes, 12 caisses, 1 pièce surdimensionnée. Les dimensions ci-dessous sont par unité.",
    "quote.unit.pallets": "Palettes",
    "quote.unit.skids": "Skids",
    "quote.unit.crates": "Caisses",
    "quote.unit.boxes": "Boîtes / Cartons",
    "quote.unit.drums": "Barils / Tonneaux",
    "quote.unit.pieces": "Pièces / Unités",
    "quote.unit.rolls": "Rouleaux",
    "quote.unit.bundles": "Bottes",
    "quote.unit.containers": "Conteneurs",
    "quote.dimensions": "Dimensions par unité (L × l × H)",
    "quote.notes": "Notes pour la répartition",
    "quote.notesPlaceholder": "Manutention spéciale, ramassage résidentiel, hauteur de quai, etc.",
    "quote.calculating": "Calcul…",
    "quote.getBestRate": "Obtenir le meilleur tarif",
    "quote.summaryRates": "Tarif le plus bas vérifié · Prix final confirmé par la répartition",
    "quote.dispatchNote": "Pensez-vous qu'on peut faire mieux ? Nos répartiteurs débloquent souvent de meilleurs tarifs sur les liaisons directes — appelez le",
    "quote.dispatchNoteOr": "ou écrivez à",
    "quote.step4.title": "Où envoyer la confirmation ?",
    "quote.fullName": "Nom complet *",
    "quote.email": "Courriel *",
    "quote.phone": "Téléphone",
    "quote.company": "Entreprise",
    "quote.selectedCarrier": "Transporteur sélectionné",
    "quote.submitting": "Envoi…",
    "quote.submitToDispatch": "Envoyer à la répartition",
    "quote.continueWith": "Continuer avec",
    "quote.selection": "Sélection",
    "quote.successOverline": "Devis envoyé",
    "quote.reference": "Référence",
    "quote.successMsg": "Notre équipe de répartition a reçu votre demande et vous contactera dans l'heure ouvrable pour confirmer le tarif et planifier le ramassage.",
    "quote.lockTitle": "Verrouillez ce tarif pour 24 heures",
    "quote.lockSub": "Conservez votre prix le temps de finaliser votre logistique.",
    "quote.locked": "Tarif verrouillé — approuvé par la répartition",
    "quote.lockedSub": "Votre prix est maintenu pendant que la répartition finalise le ramassage.",
    "quote.expiresIn": "Expire dans",
    "quote.lockBtn": "Verrouiller le tarif 24 h",
    "quote.lockToast": "Tarif verrouillé pour 24 heures. La répartition a été avisée.",
    "quote.escalate": "Besoin d'escalader ? Écrivez à",
    "quote.trackShipment": "Suivre une expédition",
    "quote.backHome": "Retour à l'accueil",
    "quote.guaranteed": "Transit garanti",
    "quote.day": "jour",
    "quote.days": "jours",
    "quote.noRates": "Aucun tarif disponible sur cette liaison en ce moment. Veuillez contacter la répartition directement.",

    // Service options
    "svcOpt.ltl.label": "Fret LTL",
    "svcOpt.ltl.desc": "Chargement partiel groupé",
    "svcOpt.ftl.label": "FTL / Fourgon sec",
    "svcOpt.ftl.desc": "Remorque complète exclusive",
    "svcOpt.flatbed.label": "Plate-forme",
    "svcOpt.flatbed.desc": "Plate-forme ouverte pour cargaison hors gabarit",
    "svcOpt.conestoga.label": "Conestoga",
    "svcOpt.conestoga.desc": "Remorque à toile rétractable",
    "svcOpt.specialized.label": "Spécialisé / Surdimensionné",
    "svcOpt.specialized.desc": "Transport lourd, permis, escortes",
    "svcOpt.container.label": "Conteneur (FCL/LCL)",
    "svcOpt.container.desc": "Fret maritime 20'/40'",
    "svcOpt.small_package.label": "Petit colis",
    "svcOpt.small_package.desc": "Coursier express",
    "svcOpt.cross_border.label": "Transfrontalier CA/US",
    "svcOpt.cross_border.desc": "Transporteurs cautionnés + douanes",
    "svcOpt.international.label": "International",
    "svcOpt.international.desc": "Porte-à-porte outre-mer",
    "svcOpt.warehousing.label": "Entreposage 3PL",
    "svcOpt.warehousing.desc": "Stockage, transbordement & préparation",

    // Track
    "track.overline": "Suivre une expédition",
    "track.headline": "Où est votre fret en ce moment ?",
    "track.sub": "Entrez votre numéro de référence pour voir le statut en temps réel.",
    "track.placeholder": "MDLGX-XXXXXX-XXXXXX",
    "track.btn": "Suivre",
    "track.searching": "Recherche…",
    "track.notFound": "Référence introuvable. Vérifiez le numéro ou contactez la répartition.",

    // Contact
    "contact.overline": "Contact",
    "contact.headline": "Parlez à un répartiteur.",
    "contact.sub": "Besoin d'un devis, d'une escalade ou simplement envie de discuter fret ? Écrivez-nous — nous répondons en moins d'une heure pendant les heures ouvrables.",
    "contact.name": "Nom complet *",
    "contact.email": "Courriel *",
    "contact.phone": "Téléphone",
    "contact.companyField": "Entreprise",
    "contact.message": "Message *",
    "contact.send": "Envoyer le message",
    "contact.sending": "Envoi…",
    "contact.success": "Message reçu. Notre équipe de répartition répondra dans l'heure ouvrable.",

    // Lead
    "lead.title": "Recevez l'info marché fret.",
    "lead.sub": "Mises à jour mensuelles des tarifs, tendances et conseils. Aucun spam.",
    "lead.placeholder": "votre@courriel.com",
    "lead.btn": "S'abonner",
    "lead.success": "Inscrit ! Surveillez votre boîte de réception.",
    "lead.dismiss": "Fermer",

    // Auth
    "auth.login.title": "Bon retour",
    "auth.login.sub": "Connectez-vous pour gérer vos devis, expéditions et profil de répartition.",
    "auth.email": "Courriel",
    "auth.password": "Mot de passe",
    "auth.login": "Connexion",
    "auth.noAccount": "Pas de compte ?",
    "auth.register": "Créer un compte",
    "auth.register.title": "Créez votre compte",
    "auth.register.sub": "Suivez devis et expéditions au même endroit.",
    "auth.name": "Nom complet",
    "auth.phone": "Téléphone (facultatif)",
    "auth.companyField": "Entreprise (facultatif)",
    "auth.createBtn": "Créer le compte",
    "auth.haveAccount": "Déjà un compte ?",
    "auth.signIn": "Connexion",
  },
};
